<template>
  <!-- 代理商新增，修改 -->
  <div>
    <el-dialog
      title="添加参加活动的课程"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <el-form label-width="120px" ref="form" :inline="true">
        <el-form-item label="课程名称">
          <el-input v-model="title" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="机构">
          <mechanism-select :mecid.sync="mecid" :condition="{type:null}"></mechanism-select>
        </el-form-item>
         <el-form-item label="包含分店">
          <el-checkbox v-model="subMec"></el-checkbox>
        </el-form-item>
        <el-form-item label="城市">
          <citySelect @change="changeCity" checkStrictly></citySelect>
        </el-form-item>
        
         <el-form-item label="主类目">
           <el-radio-group
                v-model="main_category"
                @change="changeCateType"
              >
                <el-radio label="体育运动">体育运动</el-radio>
                <el-radio label="休闲生活">休闲生活</el-radio>
                <el-radio label="夜校">夜校</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="教学类目">
          <el-select
            v-model="categories"
            clearable
            name="categories_child"
            remote
            style="width: 150px"
          >
            <el-option
              v-for="item in listPageChild"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="类型">
           <el-radio-group
                v-model="type"
              >
                <el-radio label="mechanism_offline">标准课</el-radio>
                <el-radio label="activity">活动课程</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>

      <div class="flex count">
        <p class="">筛选总数{{ Total }}</p>
        <p class="m-l20">已选{{ muti_ids.length }}</p>
      </div>

      <auto-table
        ref="atb"
        :DataList="DataList"
        :option="Option"
        :total="Total"
        @changePage="getCourseList"
        @selectionChange="selectionChange"
        rowKey="id"
      >
        <template #activity_time="{ row }">
          <div>
            <p>开始:{{ row.start_time }}</p>
            <p>结束:{{ row.end_time }}</p>
          </div>
        </template>
        <template #handler="{ row }">
          <div>
            <el-button type="primary" size="small" @click="changeCourse(row)"
              >选择</el-button
            >
          </div>
        </template>
      </auto-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addData('all')" :loading="loading"
          >添加筛选的全部数据</el-button
        >
        <el-button type="primary" :loading="loading" @click="addData('ids')"
          >添加选中的数据</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import citySelect from "@/components/select/citySelect.vue";
import { ObjectChangedValue } from "@/js/utils.js";
import cooperatorSelect from "../../../components/select/cooperatorSelect.vue";
export default {
  components: {
    citySelect,
    cooperatorSelect,
  },
  data() {
    return {
        type: 'mechanism_offline',
      clear: false,
      form: {},
      temp: {},
      dialogVisible: false,
      loading: false,
      main_category:'体育运动',
      categories: "",
      cityList: [],
      cityoptions: [],
      subMec: false,
      cityProps: {
        checkStrictly: true,
        value: "district",
        label: "district",
        children: "childrens",
      },
      activityList: [],
      DataList: [],
      Option: [
        { name: "", value: "", col_type: "selection", reserveSelection: true },
        { name: "名称", value: "title" },
        { name: "价格", value: "discount_amout" },
        { name: "课节数", value: "course_num" },
        { name: "类目", value: "categories_child" },
      ],
      Total: 0,
      key: "",
      curCourse: {},
      listPageChild: [],
      mecid: "",
      title: "",
      muti_ids: [],
    };
  },

  mounted() {
    this.getCateList();
  },

  methods: {
     changeCateType() {
      this.categories = '';
      this.getCateList();
    },
    getCateList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: "课程",
      };
      if (this.main_category != "体育运动") {
        data.source = this.main_category
      }

      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          this.listPageChild = res.data.data;
        });
    },
    //添加活动数据
    addData(type) {
      let msg = "";
      let data = {
        ...this.getFilterParam(),
        activity_id:this.form.activity_id || 0,
         activity_tag:this.form.activity_tag || null,
      };

      if (type == "all") {
        if (this.title) {
          data.title = this.title;
        }
        if (this.cityList.length > 0) {
          data.province = this.cityList[0];
          data.city = this.cityList[1] || null;
          data.district = this.cityList[2] || null;
        }
        if (this.categories) {
          data.categories_child = this.categories;
        }
        msg = `确认添加${this.Total}门课程到${this.form.activity_tag || ''}活动中？`
        if(Object.keys(data).length <= 5){
            this.$message('请选择筛选条件')
            return
        }
      } else {
        if(this.muti_ids.length == 0){
            this.$message('请选择课程')
            return
        }
        data.update_ids = this.muti_ids;
        msg = `确认添加${this.muti_ids.length}门课程到${this.form.activity_tag || '' }活动中？`
      }

      this.$confirm(msg).then(() => {
        this.loading = true;
        this.$axios({
          url: "/user/acRelative/batchAdd",
          data: data,
          method: "post",
        }).then((res) => {
          this.loading = false;
          this.dialogVisible = false;
          this.$message('添加成功')
          this.$emit("success",true)
        }).catch(err=>{
            this.loading = false;
        })
      });
    },
    selectionChange(v) {
      this.muti_ids = v.map((t) => t.id);
    },
    changeCity(v) {
      this.cityList = v;
    },
    changeCourse(row) {
      this.curCourse = row;
      this.form.pic = row.face_url;
      this.temp.pic = row.face_url;
      this.form.amount = row.discount_amout;
      this.DataList = [];
    },
    search() {
      this.$refs.atb.clearAllSelection();
      this.getCourseList(1);
    },


    getFilterParam(){
      let param = {
        subMec: this.subMec,
        type: this.type,
        categories: this.main_category,
        status: 2,
      }
       if (this.title) {
        param.title = this.title;
      }
      if (this.cityList.length > 0) {
        param.province = this.cityList[0];
        param.city = this.cityList[1] || null;
        param.district = this.cityList[2] || null;
      }
      if (this.mecid) {
        param.mechanism_id = this.mecid;
      }
      if (this.categories) {
        param.categories_child = this.categories;
      }


      return param
    },
    //获取列表
    getCourseList(v) {
      let page = v || 1;
      let data = {
        currentPage: page,
        pageSize: 10,
       ...this.getFilterParam()
      };
     
      this.$axios({
        url: "/user/masterSetPrice/queryFilter",
        params: data,
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    open(info) {
      this.form = info;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.count {
  padding: 10px 30px;
  font-size: 16px;
}
</style>